<template>
    <div>
        <van-nav-bar
                title="设置佣金"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />

            <van-field
                    v-model="form.username"
                    name="姓名"
                    label="账号"
                    required
                    placeholder="请输入代理商账号并查询"
                    message="请填写账号"
            >
                <template #button>
                    <van-button size="small" @click="search" type="primary">查询</van-button>
                </template>
            </van-field>
      <template v-if="agentlist && agentlist.length>1">
        <div style="font-size: 14px;background: #eee;height: 30px;line-height: 30px;padding: 0 10px;">请点击要设置的账号:</div>
        <van-cell class="cell" title-class="cell-title" :title="item.username" v-for="(item,index) in agentlist" :key="index" is-link  @click="searchByID(item.id)"/>
      </template>
        <div v-show="list.length > 0" class="input-list">
            <p style="font-size: 13px;color: #3a8ee6;text-indent: 14px;">请直接在输入框中，编辑然后提交保存</p>
            <van-field
                    type="number"
                    label-width="3rem"
                    input-align="right"
                    v-for="(item,id) in list"
                    :label="item.name"
                    :border="true"
                    :key="id"
                    placeholder="请点击此处进行设置"
                    v-model="item.commission"
            >

            </van-field>
            <div style="margin: 16px;">
                <van-button round block type="info" @click="onSubmit">
                    保存
                </van-button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "agentadd",
        data() {
            return {
                show:false,
              agentlist:[],
                form:{
                    username:''
                },
                list:[]
            };
        },
        methods: {
            onClickLeft(){
                window.history.go(-1)
            },

            onSubmit(){
                const postData = {
                    agentID:this.form.agentID,
                    commissions:this.list
                }
                this.$toast.loading('保存中')
                this.fetchDataPost('/Agentcommission/setCommission',postData,(res)=>{
                    this.$toast.clear()
                    if(res.code){
                        this.search()
                        this.$toast.success(res.msg)
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
          searchByID(id){
            this.form.agentID = id
            this.agentlist =[]
            this.fetchData('/Agentcommission/queryList',{id:this.form.agentID},(res)=>{
              if(res.code && res.data){
                this.list = res.data
                this.$toast.clear()
              }else if(res.msg){
                this.$toast.clear()
                this.$toast.fail(res.msg)
              }else{
                this.$toast.clear()
                this.$toast.fail('查询失败')
              }
            })
          },
            search(){
                if(!this.form.username){
                    this.$toast.fail('请输入账号再查询')
                    return false;
                }
              this.agentlist =[]
                this.$toast.loading('查询中')
                this.list = [];
                this.form.agentID = 0;
                this.fetchData('/agent/queryList',{keywords:this.form.username},(res)=>{
                    if(res.data.data && res.data.data.length == 1){
                        this.form.agentID = res.data.data[0].id
                        this.fetchData('/Agentcommission/queryList',{id:this.form.agentID},(res)=>{
                            if(res.code && res.data){
                                this.list = res.data
                                this.$toast.clear()
                            }else if(res.msg){
                                this.$toast.clear()
                                this.$toast.fail(res.msg)
                            }else{
                                this.$toast.clear()
                                this.$toast.fail('查询失败')
                            }
                        })

                    }else if(res.data.data && res.data.data.length >1){
                      this.agentlist = res.data.data

                    }else{
                        this.$toast.clear()
                        this.$toast.fail('无法查询到该账号')
                    }
                })

            }
        },
        created: function () {

        }
    };
</script>
<style>
    .input-list .van-field__body{

            border-bottom: 1px solid #3a8ee6 !important;

    }
</style>



// WEBPACK FOOTER //
// src/pages/setCommission.vue